import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class FontService {

  private fontFamilies: any = {
    //'ar': 'Readex Pro',
    'ar': 'NotoSansArabic',
    'en': 'sans-serif',
    'fa': 'Peyda, sans-serif'
  };

  constructor(private router: Router) { }

  getFontFamily() {
    const lang = this.router.url.split('/')[1];
    return this.fontFamilies[lang] || 'Peyda';

  }

  init() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const fontFamily = this.getFontFamily();
        document.body.style.fontFamily = fontFamily;
      }
    });
  }

}
